import React, { Component } from 'react';
import { connect } from 'react-redux';
import { alertSuccess } from '../actions/alertActions';
import { api } from '../services/rest';
import BuildInProgress from './BuildInProgress';
import Menu from './Menu';

class Preview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            previewIsReady: false,
            previewUrl:''
        }
        this.compilePreview = this.compilePreview.bind(this);
    }

    componentDidMount() {
        this.compilePreview();
    }

    compilePreview() {
        //console.log(this.props);
        api.post(`/Preview/${this.props.client}/${this.props.project}/Build`)
            .then(res => this.setState({ previewIsReady: true, previewUrl: res.data }));
    }

    render() {
        var style = {
            width: '100%',
            height: '100vh',
            //position: 'fixed',
            top: 0,
            display: 'flex',
            flexDirection:'row'
        };

        var completeStyle = {
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: '10vh'
        }

        var previewUrl = this.state.previewUrl;
        const preview =
            <div style={style}>
                <div>
                    <Menu className="sidebar sidebar-inverse pr-0 pl-0" client={this.props.client} project={this.props.project} />
                </div>
                <div style={completeStyle}>
                    <h2>Build Complete</h2>
                    <div>
                        <a href={previewUrl} target="_blank" rel="noopener noreferrer">Click here to visit the Preview site</a>
                    </div>
                </div>
            </div>

        if (this.state.previewIsReady) return preview;
        else return <BuildInProgress/>
    }
}

export default connect(null, { alertSuccess })(Preview);
//<Link className="btn btn-default" to={`/${this.props.client}/${this.props.project}/Publish`}>Publish changes</Link>
//<iframe title={this.props.project} src={`${config.apiUrl}/Preview/${this.props.client}/${this.props.project}/Page/index`} style={style} />
//<div className="panel panel-default fix-bottom-right mr-lg shadow" >
//<div className="panel-body" >
//    <Link className="btn btn-primary mr-lg" to={`/${this.props.client}/${this.props.project}`}>Continue editing</Link>
//</div>
//</div >